export enum SessionWorkerMessageType {
  REFRESH_TOKEN = "refresh_token",
}
